export const permissionData = [
  {
      //header - search
      "id": 582,
      "role_id": 8,
      "permission_id": 1,
      "allow": 1,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // header - dashboard Insight
      "id": 583,
      "role_id": 8,
      "permission_id": 2,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // header - dashboard spm
      "id": 584,
      "role_id": 8,
      "permission_id": 3,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // header - dashboard csi
      "id": 585,
      "role_id": 8,
      "permission_id": 4,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // header - dashboard event
      "id": 586,
      "role_id": 8,
      "permission_id": 5,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // header - my request
      "id": 587,
      "role_id": 8,
      "permission_id": 6,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // header - approval sheet
      "id": 588,
      "role_id": 8,
      "permission_id": 7,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // header - user role setting legal
      "id": 589,
      "role_id": 8,
      "permission_id": 8,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // header - user role setting dokument
      "id": 590,
      "role_id": 8,
      "permission_id": 9,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // header - master data
      "id": 591,
      "role_id": 8,
      "permission_id": 10,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // header - export to excel
      "id": 592,
      "role_id": 8,
      "permission_id": 11,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // header - advance search
      "id": 593,
      "role_id": 8,
      "permission_id": 12,
      "allow": 1,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // front page - view page
      "id": 594,
      "role_id": 8,
      "permission_id": 13,
      "allow": 1,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // front page - click icon
      "id": 595,
      "role_id": 8,
      "permission_id": 14,
      "allow": 1,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // front page - konfirmasi ?
      "id": 596,
      "role_id": 8,
      "permission_id": 15,
      "allow": 1,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // front page - reset
      "id": 597,
      "role_id": 8,
      "permission_id": 16,
      "allow": 1,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 1 - view page
      "id": 598,
      "role_id": 8,
      "permission_id": 17,
      "allow": 1,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 1 - filter
      "id": 599,
      "role_id": 8,
      "permission_id": 18,
      "allow": 1,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 1 - urutkan ?
      "id": 600,
      "role_id": 8,
      "permission_id": 19,
      "allow": 1,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 1 - search
      "id": 601,
      "role_id": 8,
      "permission_id": 20,
      "allow": 1,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 profil - view page
      "id": 602,
      "role_id": 8,
      "permission_id": 21,
      "allow": 1,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 profil - extend to sap
      "id": 603,
      "role_id": 8,
      "permission_id": 22,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 profil - block vendor
      "id": 604,
      "role_id": 8,
      "permission_id": 23,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 profil - unblock vendor
      "id": 605,
      "role_id": 8,
      "permission_id": 24,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 profil - delete vendor
      "id": 606,
      "role_id": 8,
      "permission_id": 25,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 profil - change logo
      "id": 607,
      "role_id": 8,
      "permission_id": 26,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 informasi - view page
      "id": 608,
      "role_id": 8,
      "permission_id": 27,
      "allow": 1,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 informasi - repraqualifikasi
      "id": 609,
      "role_id": 8,
      "permission_id": 28,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 informasi - update landing page
      "id": 610,
      "role_id": 8,
      "permission_id": 29,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 informasi - edit
      "id": 611,
      "role_id": 8,
      "permission_id": 30,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 1 detail po - view page
      "id": 612,
      "role_id": 8,
      "permission_id": 31,
      "allow": 1,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 1 detail po - search
      "id": 613,
      "role_id": 8,
      "permission_id": 32,
      "allow": 1,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 detail po - grafic
      "id": 614,
      "role_id": 8,
      "permission_id": 33,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 legal doc - view page
      "id": 615,
      "role_id": 8,
      "permission_id": 34,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 legal doc - download legal doc akta
      "id": 616,
      "role_id": 8,
      "permission_id": 35,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 legal doc - download legal doc komersial
      "id": 617,
      "role_id": 8,
      "permission_id": 36,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 legal doc - download legal doc perizinan
      "id": 618,
      "role_id": 8,
      "permission_id": 37,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 legal doc - edit legal doc - akta
      "id": 619,
      "role_id": 8,
      "permission_id": 38,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 legal doc - edit legal doc komersial
      "id": 620,
      "role_id": 8,
      "permission_id": 39,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 legal doc - edit legal doc perizinnan
      "id": 621,
      "role_id": 8,
      "permission_id": 40,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 total event - view page
      "id": 622,
      "role_id": 8,
      "permission_id": 41,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 total event - search 
      "id": 623,
      "role_id": 8,
      "permission_id": 42,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  { 
      // level 2 sio - view page
      "id": 624,
      "role_id": 8,
      "permission_id": 43,
      "allow": 1,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 sio - edit
      "id": 625,
      "role_id": 8,
      "permission_id": 44,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 kinerja k3l - view page
      "id": 626,
      "role_id": 8,
      "permission_id": 45,
      "allow": 1,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 kinerja k3l - edit k3l
      "id": 627,
      "role_id": 8,
      "permission_id": 46,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 k3l - download attachment
      "id": 628,
      "role_id": 8,
      "permission_id": 47,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 kplh - view page
      "id": 629,
      "role_id": 8,
      "permission_id": 48,
      "allow": 1,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 kplh - edit kplh
      "id": 630,
      "role_id": 8,
      "permission_id": 49,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 kplh - download attachment
      "id": 631,
      "role_id": 8,
      "permission_id": 50,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 kinerja kontrak - view page
      "id": 632,
      "role_id": 8,
      "permission_id": 51,
      "allow": 1,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 kinerja kontrak - search
      "id": 633,
      "role_id": 8,
      "permission_id": 52,
      "allow": 1,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 kinerja kontrak - email
      "id": 634,
      "role_id": 8,
      "permission_id": 53,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 kinerja po - view page
      "id": 635,
      "role_id": 8,
      "permission_id": 54,
      "allow": 1,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 kinerja po - search
      "id": 636,
      "role_id": 8,
      "permission_id": 55,
      "allow": 1,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 kinerja po - email
      "id": 637,
      "role_id": 8,
      "permission_id": 56,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 kinerja po - no
      "id": 638,
      "role_id": 8,
      "permission_id": 57,
      "allow": 1,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 kinerja po - nomor po
      "id": 639,
      "role_id": 8,
      "permission_id": 58,
      "allow": 1,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 kinerja po - tanggal po
      "id": 640,
      "role_id": 8,
      "permission_id": 59,
      "allow": 1,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 kinerja po - nilai po
      "id": 641,
      "role_id": 8,
      "permission_id": 60,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 kinerja po - nilai rata rata
      "id": 642,
      "role_id": 8,
      "permission_id": 61,
      "allow": 1,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 kinerja po - gr kuantitas
      "id": 643,
      "role_id": 8,
      "permission_id": 62,
      "allow": 1,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // level 2 kinerja po - keterangan
      "id": 644,
      "role_id": 8,
      "permission_id": 63,
      "allow": 1,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // my request - view page
      "id": 645,
      "role_id": 8,
      "permission_id": 64,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // my request vendor baru
      "id": 646,
      "role_id": 8,
      "permission_id": 65,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // my request - extend to sap
      "id": 647,
      "role_id": 8,
      "permission_id": 66,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // my request - block vendor
      "id": 648,
      "role_id": 8,
      "permission_id": 67,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // my request - unblock vendor
      "id": 649,
      "role_id": 8,
      "permission_id": 68,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // my request - filter
      "id": 650,
      "role_id": 8,
      "permission_id": 69,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // my request - search
      "id": 651,
      "role_id": 8,
      "permission_id": 70,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // my request - view request
      "id": 652,
      "role_id": 8,
      "permission_id": 71,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // my request - csi score
      "id": 653,
      "role_id": 8,
      "permission_id": 72,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // approval sheet - page
      "id": 654,
      "role_id": 8,
      "permission_id": 73,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // approval sheet - refresh
      "id": 655,
      "role_id": 8,
      "permission_id": 74,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // approval sheet - view request
      "id": 656,
      "role_id": 8,
      "permission_id": 75,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // approval sheet k3l - review k3l
      "id": 657,
      "role_id": 8,
      "permission_id": 76,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // approval sheet k3l - delegasi k3l
      "id": 658,
      "role_id": 8,
      "permission_id": 77,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // approval sheet k3l - download attachment k3l
      "id": 659,
      "role_id": 8,
      "permission_id": 78,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // approval sheet k3l - upload attachment k3l
      "id": 660,
      "role_id": 8,
      "permission_id": 79,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // approval sheet kplh - review kplh
      "id": 661,
      "role_id": 8,
      "permission_id": 80,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // approval sheet kplh - delegasi kplh
      "id": 662,
      "role_id": 8,
      "permission_id": 81,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // approval sheet kplh - download attachment kplh
      "id": 663,
      "role_id": 8,
      "permission_id": 82,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  },
  {
      // approval sheet kplh - upload attachment kplh
      "id": 664,
      "role_id": 8,
      "permission_id": 83,
      "allow": 0,
      "createdAt": "2022-01-17T07:20:03.000Z",
      "updatedAt": "2022-01-17T07:20:03.000Z"
  }
]
